import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import { useState, useReducer } from "react"
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { useEffect } from "react"
import Loader from "../../../shared/Loader/Loader"
import Pagination from "../../../shared/Pagination/Pagination"
import AddNewInsuranceCategory from "./AddNewInsurranceCategory"
import SearchHeader from "../../Shared/SearchHeader"
import Card from "../../Shared/Card"
import Table from "../../Shared/Table"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { connect } from "react-redux"
import usePagination from "../../../../customhooks/usePagination"
const InsurranceCategory = (props) => {
    const API_URL = enumUtil.controller.General
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);

    const [InsuranceCategoryID, setInsuranceCategoryID] = useState();
    const [searchParam, setSearchParam] = useState();
    const [IsOpenInsuranceCategory, setIsOpenInsuranceCategory] = useState(false);
    const [InsuranceCategoryData, setInsuranceCategoryData] = useState([]);
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    const [totalCounts, setTotalCounts] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false
    }

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    ///////////
    const LoadData = (param, types) => {
        setIsLoading(true)
        setInsuranceCategoryData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.InsurranceCategory,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setInsuranceCategoryData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setIsOpenInsuranceCategory(true)
                }
            }
        }).catch((error) => {
            setTotalCounts(0)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (InsuranceCategoryData?.length == 0 && isNull(searchParamType)) {
                    setIsOpenInsuranceCategory(true)
                }
            }
        })
    }
    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }
    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])

    const AddInsuranceCategory = (ID) => {
        setIsOpenInsuranceCategory(true)
        setInsuranceCategoryID(ID)
    }
    const CloseInsuranceCategory = () => {
        setIsOpenInsuranceCategory(false)
    }
    const DeleteInsuranceCategory = () => {
        setIsOpenInsuranceCategory(false)
        setIsClose((Math.random()));
    }
    let PopupScreen = "";
    if (IsOpenInsuranceCategory) {
        PopupScreen = <AddNewInsuranceCategory IsOpenInsuranceCategory={IsOpenInsuranceCategory} onClose={CloseInsuranceCategory} onDeleteInuranceC={DeleteInsuranceCategory} InsuranceCategoryID={InsuranceCategoryID} type={type} />
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [

        {
            key: 'Name',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Category Name'} sortIcon={true} type={'string'} colKey={'Name'} data={InsuranceCategoryData} setData={setInsuranceCategoryData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddInsuranceCategory(row.InsuranceCategoryID)}>{row.Name} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.InsuranceCategoryID, row.Name)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.InsuranceCategoryID}-${row.Name}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={InsuranceCategoryData} setData={setInsuranceCategoryData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Description}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.InsuranceCategoryID, row.Description)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.InsuranceCategoryID}-${row.Description}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'UpdatedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Updated By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={InsuranceCategoryData} setData={setInsuranceCategoryData} />),
            resizable: true,
        },
        {
            key: 'UpdatedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Updated Date'} sortIcon={true} type={'string'} colKey={'UpdatedDate'} data={InsuranceCategoryData} setData={setInsuranceCategoryData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.UpdatedDate}
                        </div>
                    </>
                );
            }
        },

    ]
    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
    const handleClearSearch = () => {
        setSearchParam('')
    }
    const InsuranceCategoryBody = () => {
        return (
            <>
                <div className={show ? 'container-fluid action-row br-bottom-1 br-clr' : 'container-fluid action-row br-clr'}>
                    <div className="row justify-content-between">
                        <div className="col-4">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by name or id…'
                                        onChange={e => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter} value={searchParam} />
                                    {searchParam?.length > 0 ?
                                        <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                            <i className="bi bi-x"></i>
                                        </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                            <i className="bi bi-search"></i>
                                        </span>}
                                </div>
                            </div>
                        </div>
                        <div className="col-8 ps-0">
                            <SearchHeader
                                AddNew={AddInsuranceCategory}
                                Excel={handleExcel}
                                PDF={handlePdf}
                                Delete={handleDelete}
                                Filter={handleFilter}
                                cardView={CardView}
                                tableView={TableView}
                                show={show}
                                searchButton={searchButton}
                                Key={623}
                                Name={'Insurrance Category'}
                                Counts={totalCounts}
                            />
                        </div>
                    </div>
                </div>

                {isLoading ? <Loader /> : null}
                {show ?
                    <Card
                        AddNew={AddInsuranceCategory}
                        Data={InsuranceCategoryData}
                        API_URL={API_URL}
                        TableName={enumUtil.enumAPITableName.InsurranceCategory}
                        DeleteInsuranceCategory={DeleteInsuranceCategory}
                        Key={623}
                        Name={'Insurrance Category'}
                    />
                    : (
                        <Table
                            columns={columns}
                            rows={InsuranceCategoryData}
                            height='500px'
                            rowClass={rowClass}
                            // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                            dynamicClass='fill-grid DataGrid-Table hk-exp-table insurance_code_table'
                            rowHeight={25}
                            PerPage={PerPage}
                            PageNo={PageNo}
                            TotalPages={TotalPages}
                            handlePageClick={handlePageClick}
                            PreviousPage={PreviousPage}
                            handleFingByCreteria={handleFingByCreteria}
                            NextPage={NextPage}
                            Key={623}
                            Name={'Insurrance Category'}
                            isLoading={isLoading}
                            TableName={'InsurranceCategory'}
                            handleSelectData={handleSelectData}
                            LoadData={() => LoadData(searchParam)}
                            ClearSearch={handleClearSearch}
                        />
                    )
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(InsuranceCategoryData?.length == 0 && isNull(searchParamType)){
    //             setIsOpenInsuranceCategory(true)
    //         }
    //     }
    // },[InsuranceCategoryData, searchParamType])
    return (
        <>
            {/* {PopupScreen} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {InsuranceCategoryData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {IsOpenInsuranceCategory ? <>{PopupScreen}</> : <>{InsuranceCategoryBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {InsuranceCategoryBody()}
                </>
            }


        </>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer
    }
}
export default connect(mapStateToProps)(InsurranceCategory)